import AbortError from '@errors/AbortError'
import BadRequestError from '@errors/BadRequestError'
import HttpError from '@errors/HttpError'
import NetworkError from '@errors/NetworkError'
import SignedOutError from '@errors/SignedOutError'

// 端末アサーション失効（401 device_assertion_required）時のリフレッシュ関数。
// med_application のみ deviceKey 経由で登録する（患者向けは未登録＝従来動作）。
let assertionRefresher: (() => Promise<void>) | null = null
export const setAssertionRefresher = (fn: () => Promise<void>): void => {
  assertionRefresher = fn
}

const fetchApi = async <T = unknown>(
  url: string,
  init: RequestInit,
  retried = false
): Promise<T> => {
  let res: Response
  try {
    res = await fetch(url, { redirect: 'error', ...init })
  } catch (e) {
    if ((e as Error).name === 'AbortError') throw new AbortError()
    throw new NetworkError((e as Error).message)
  }
  if (res.status === 401) {
    if (!retried && assertionRefresher) {
      const body = await res.json().catch(() => null)
      if (body && (body as { error?: string }).error === 'device_assertion_required') {
        await assertionRefresher()
        return fetchApi<T>(url, init, true)
      }
    }
    const err = new SignedOutError()
    window.location.reload()
    throw err
  }
  if (res.status === 204) return undefined as T
  const body = await res.json().catch(() => undefined)
  if (res.ok) return body as T
  if (res.status === 400) throw new BadRequestError(body, res)
  throw new HttpError(res.status, body, res)
}

export default fetchApi
